import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=715fbb2c&scoped=true"
import script from "./videoItem.vue?vue&type=script&lang=js"
export * from "./videoItem.vue?vue&type=script&lang=js"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=715fbb2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715fbb2c",
  null
  
)

export default component.exports